module.exports = __webpack_public_path__ + "static/media/call_made.4996f159.svg";